"use client";

import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useCookieBanner } from "cookiebanner-finally";
import { CookieSettings } from "@/components/global/ui/CookieSettings";
import Flare from "@/components/global/ui/Flare";
import { Button } from "@/shadcn/ui/button";

export function CookieBanner() {
  const { isVisible, acceptAll, denyAll } = useCookieBanner();
  const [showSettings, setShowSettings] = useState(false);
  const [hasScrolled, setHasScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 500) {
        setHasScrolled(true);
        window.removeEventListener("scroll", handleScroll);
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (showSettings) {
    return <CookieSettings onClose={() => setShowSettings(false)} />;
  }

  return (
    <AnimatePresence>
      {isVisible && hasScrolled && (
        <motion.div
          initial={{ y: "100%" }}
          animate={{ y: 0 }}
          exit={{ y: "100%" }}
          transition={{
            type: "spring",
            stiffness: 300,
            damping: 30,
            duration: 0.3,
          }}
          className="fixed right-0 bottom-0 left-0 z-[9999] backdrop-blur-[2rem]"
        >
          <div className="bg-gradient-to-b from-[#0B0F13] from-[11.57%] to-[#98D8FF] to-[719.35%] overflow-clip">
            <div className="relative">
              <div className="flex flex-col gap-4 items-start mx-auto max-w-6xl lg:gap-6 lg:items-center py-[6rem] px-[2.5rem] sm:px-[6rem]">
                <div className="flex-1">
                  <h3 className="mb-2 text-[3.5rem] font-semibold text-white font-news">
                    We use cookies
                  </h3>
                  <p className="text-[2rem] lg:text-[2.25rem] leading-relaxed text-gray-300">
                    We use cookies and similar technologies to provide you with
                    the best possible experience on our website. Some are
                    necessary for functionality, others help us improve the
                    website and show you relevant content.
                  </p>
                </div>

                <div className="flex flex-col w-full lg:flex-row lg:flex-shrink-0 gap-[1rem]">
                  <Button onClick={acceptAll} variant="default">
                    Accept All
                  </Button>

                  <Button onClick={denyAll} variant="white">
                    Reject All
                  </Button>

                  <Button
                    onClick={() => setShowSettings(true)}
                    variant="whiteFaded"
                  >
                    Show Details
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
